import { SemiBoldText } from '../../../../utils/typography/BaseText';

export const StaySmallSmallStay = () => {
  return (
    <div className="px-2 lg:px-6">
      <h2 className="text-[23px] font-semibold mb-6 ">Stay</h2>
      <hr />
    </div>
  );
};
